module.exports = __webpack_public_path__ + "img/step3-basket2.b1308dd8.png";